/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
// CONSTANTS are all caps.
const NS = 'CountdownTimerBlock';
const CLS = 'countdownTimerBlock';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/countdownTimerBlock.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import moment from 'moment';
import countdown from 'countdown';

export class CountdownTimerBlock {
	constructor($el) {
		// $el is the widget node return by the loadCountdownTimerBlock function
		this.$el = $el;
	}

	init() {
		this.setCountdownTimerBlock();
	}

	setCountdownTimerBlock() {
		// Add Some logic here
		const This = this;
		const $wg = $(this.$el);
		// get target timestamp and convert to a date object
		let deadlineDateTimestamp = $wg.data('deadlineDate') || 0;
		let targetDate = new Date(deadlineDateTimestamp * 1000);
		// get current timestamp
		let cuurentUTCDate = new Date().toUTCString();
		let currentTimestamp = moment(moment.utc(cuurentUTCDate)).unix();
		// only start the timer if the current timestamp is smaller than the target
		if (currentTimestamp < deadlineDateTimestamp) {
			let weeks = $wg.find('.weeks span').first();
			let days = $wg.find('.days span').first();
			let hours = $wg.find('.hours span').first();
			let minutes = $wg.find('.minutes span').first();
			let seconds = $wg.find('.seconds span').first();
			let timer = countdown(targetDate, function(ts) {
				let cuurentUTCDate = new Date().toUTCString();
				let currentTimestamp = moment(moment.utc(cuurentUTCDate)).unix();
				if (currentTimestamp >= deadlineDateTimestamp) {
					window.clearInterval(timer);
					This.showEndMessage();
				} else {
					// update units
					weeks.text(This.pad2(ts.weeks));
					days.text(This.pad2(ts.days));
					hours.text(This.pad2(ts.hours));
					minutes.text(This.pad2(ts.minutes));
					seconds.text(This.pad2(ts.seconds));
				}
			}, countdown.WEEKS|countdown.DAYS|countdown.HOURS|countdown.MINUTES|countdown.SECONDS);
		} else {
			// show the done message
			This.showEndMessage();
		}
	}

	showEndMessage() {
		const $wg = $(this.$el);
		$wg.find(WG + 'counter').addClass('d-none');
		$wg.find(WG + 'title').addClass('d-none');
		$wg.find(WG + 'done').removeClass('d-none').fadeIn('fast');
	}

	pad2(number) {
		return (number < 10 ? '0' : '') + number;
	}

	// Add more functions like on above here
}
